import React, { createContext, useReducer, useEffect, useContext, useState } from "react";
import { Tabs, Row, Col, Button, Input, Select, Switch, Form, message, Space } from 'antd';
import { UserOutlined, LaptopOutlined, NotificationOutlined, DeleteFilled, ZoomInOutlined, PlusOutlined } from '@ant-design/icons';

import Advice from './advice';
import Instructions from './instructions';
import Medications from './medications';
import Investigation from './investigation';
import Procedure from './procedure';
import { layout } from '../../commonImports/import1';
import slugify from 'slugify';
import { createOrderSet, updateOrderSet } from '../../../graphql/mutations';
import Diagnosis from './diagnosis';
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { ageGroup, genderValues } from '../../commonImports/data';



const updateOrderSetMut = async (props, variables) => {
    return await new Promise((res, rej) => {
        props.client.mutate({
            mutation: updateOrderSet,
            variables: variables,
        }).then(({ data }) => {
            res(data)
        }).catch((err) => {
            rej(err)
        })
    })
};


const GroupUpdate = (props) => {


    const [form] = Form.useForm();
    const [loading, setloading] = useState(false);
 
    const [type, settype] = useState('INVESTIGATIONS');


    const runMutation = (arr) => {
        setloading(true)
        Promise.allSettled(arr)
            .then((res) => {
                message.success('Successfully updated')
                if(props.updateMainList){
                    props.updateMainList()
                }
                setloading(false)
            })
            .catch((err) => {
             
                if (err.graphQLErrors)
                    err.graphQLErrors.map((res) => {
                        if (res.errorType == 'DynamoDB:ConditionalCheckFailedException') {
                            message.error('This orderset is already created.')
                        } else {
                            message.error('There is some error in saving form')
                        }
                    });
                if (err.networkError) console.log(`[Network error]: ${err.networkError}`);
                setloading(false)
            })
    }


    const createOrsersetMutationFunc = (obj) => {
        return new Promise(async (resolve, reject) => {
            let res = await updateOrderSetMut(props, obj);
            if (res.updateOrderSet != null) {
                resolve(res)
            } else {
                reject('Error')
            }
        })
    }

    return (
        <div>
            <Form
                // initialValues={initialValues}
                form={form}
                {...layout}
                onFinish={(values) => {
                    console.log(values);
               
                    let ageGroupItem = [];
                    if (values.ageGroup) {
                        ageGroupItem = ageGroup.filter((a) => values.ageGroup.includes(a.type))
                    }

                  
                        let obj = {}
                        let typeValue = 'global';

                        obj = {
                            advice: values.advice && values.advice.length > 0 ? values.advice : undefined ,
                            procedure: values.procedure && values.procedure.length > 0 ? values.procedure : undefined ,
                            medication: values.medication && values.medication.length > 0 ? values.medication.map((a) => {
                                delete a['__typename']
                                return a
                            }) : undefined ,
                            note: values.note,
                            investigation: values.investigation && values.investigation.length > 0 ? values.investigation : undefined ,
                            active: values.active ? values.active : undefined,
                            ageGroup: ageGroupItem.length > 0 ? ageGroupItem : undefined ,
                            appliedFor: values.appliedFor ? values.appliedFor : undefined
                        }
                   
                        let arr = []
                        props.selectedGroup.group.forEach((v) => {
                            obj.typeValue = v.typeValue;
                            obj.slugValue = v.slugValue;
                            obj.orderSetName = v.orderSetName;
                            obj.searchField = v.searchField;
                            obj.diagnosis = v.diagnosis;
                         
                            arr.push(
                                createOrsersetMutationFunc(obj)
                            )
                        })

                        runMutation(arr)
                    
                }}

                onFinishFailed={(err) => {
                    console.log(err)
                    message.error('Please check all fields')
                }}
            >
                <Space>

                <Select value={type} placeholder="Select Type" style={{ width: '400px' }} onChange={(val) => {
                            settype(val)
                        }}>
                            {['INVESTIGATIONS', 'PROCEDURES', 'MEDICATION', 'ADVICE', 'INSTRUCTIONS', 'OTHER DETAILS'].map((a) => {
                                return (
                                    <Select.Option key={a} value={a}>
                                        {a}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                        <Button type="primary" htmlType="submit">Update</Button>
                </Space>
                <Row gutter={24} style={{marginTop:'20px'}}>
                   
                    {type == 'INVESTIGATIONS' &&
                        <Col span={24}><Investigation form={form} /></Col>
                    }
                    {type == 'PROCEDURES' &&
                        <Col span={24}>
                            <Procedure form={form} />
                        </Col>
                    }
                    {type == 'MEDICATION' &&
                        <Col span={24}><Medications form={form} /></Col>
                    }
                    {type == 'ADVICE' &&
                        <Col span={24}><Advice form={form} /></Col>
                    }

                    {type == 'INSTRUCTIONS' &&
                        <Col span={24}><Instructions form={form} /></Col>
                    }
                    {type == 'OTHER DETAILS' &&

                        <>
                            <Col span={6}>
                                <Form.Item
                                    name="ageGroup"
                                    label="Age Group"
                                >
                                    <Select mode="multiple" placeholder="Age Group" allowClear style={{ width: '100%' }}>
                                        {ageGroup.map((a) => {
                                            return (
                                                <Select.Option key={a.type} value={a.type}>
                                                    {a.type + ' ' + a.ageFrom + ' - ' + a.ageTo + ' ' + 'Yr'}
                                                </Select.Option>
                                            )
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item
                                    name="appliedFor"
                                    label="Gender"
                                >
                                    <Select placeholder="Gender" allowClear style={{ width: '100%' }}>
                                        {genderValues.map((a) => {
                                            return (
                                                <Select.Option key={a} value={a}>
                                                    {a}
                                                </Select.Option>
                                            )
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            {/* <Col>
                                <Form.Item
                                    name="active"
                                    label="Status"
                                >
                                    <Switch size="small"
                                        // checked={record ? record.active : true}
                                        onChange={(checked) => {
                                            form.setFieldsValue({
                                                active: checked
                                            })
                                        }} />
                                </Form.Item>
                            </Col> */}

                        </>
                    }


                </Row>

            </Form>
        </div>
    )
}

export default withApollo(withRouter(GroupUpdate));